import { useMutation } from '@zg-rentals/react-query5';
import { user } from '@/src/lib/api/endpoints/user';
import { USER_LISTINGS_TAG } from './queryTags';

export const useAddUserItem = () => {
  return useMutation({
    mutationFn: ({ type, alias }: { type: string; alias: string }) => user.addUserItem(type, alias),
    meta: {
      invalidates: [USER_LISTINGS_TAG],
      context: {
        api: 'hotpads-api',
        details: 'add user item',
      },
    },
  });
};

export const useRemoveUserItem = () => {
  return useMutation({
    mutationFn: ({ type, alias }: { type: string; alias: string }) => user.removeUserItem(type, alias),
    meta: {
      invalidates: [USER_LISTINGS_TAG],
      context: {
        api: 'hotpads-api',
        details: 'remove user item',
      },
    },
  });
};
